/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportCaseResultDto } from '../../models/financial-support-case-result-dto';

export interface FinancialSupportCaseControllerRunAnalysis$Params {
  id: string;

/**
 * 분석 케이스 생성 시 발급한 비회원 세션 토큰
 */
  'X-Financial-Support-Token': string;
}

export function financialSupportCaseControllerRunAnalysis(http: HttpClient, rootUrl: string, params: FinancialSupportCaseControllerRunAnalysis$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseResultDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportCaseControllerRunAnalysis.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Financial-Support-Token', params['X-Financial-Support-Token'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportCaseResultDto>;
    })
  );
}

financialSupportCaseControllerRunAnalysis.PATH = '/api/financial-support/cases/{id}/analysis';
